/* eslint-disable camelcase */
export enum ConsultancyLegalTypes {
  GET_DICAS_REQUEST = '@dica_legal/GET_DICAS_REQUEST',
  GET_DICAS_SUCCESS = '@dica_legal/GET_DICAS_SUCCESS',
  GET_DICAS_FAILURE = '@dica_legal/GET_DICAS_FAILURE',
  GET_CREATE_REQUEST = '@dica_legal/GET_CREATE_REQUEST',
  GET_CREATE_SUCCESS = '@dica_legal/GET_CREATE_SUCCESS',
  GET_CREATE_FAILURE = '@dica_legal/GET_CREATE_FAILURE',
  GET_POSTS_REQUEST = '@dica_legal/GET_POSTS_REQUEST',
  GET_POSTS_SUCCESS = '@dica_legal/GET_POSTS_SUCCESS',
  GET_POSTS_FAILURE = '@dica_legal/GET_POSTS_FAILURE',
}

export interface PostTypes {
  title: string;
  post_tip: {
    content: {
      rendered: string;
    };
  };
}

export interface DicaLegalTypes {
  title: {
    rendered: string;
  };
  excerpt: {
    rendered: string;
  };
  link: string;
  id: number;
  title_posts: string;
}

export interface DicaLegalDataTypes {
  dica_legal: Array<DicaLegalTypes>;
  post: Array<PostTypes>;
}

export interface RequestState {
  get_posts: {
    loading: boolean;
    loaded: boolean;
    error: boolean;
  };
  create: {
    loading: boolean;
    loaded: boolean;
    error: boolean;
  };
  posts: {
    loading: boolean;
    loaded: boolean;
    error: boolean;
  };
}

export interface ConsultancyLegalState {
  dica_legal: DicaLegalDataTypes;
  readonly request: RequestState;
}
